export default "__VITE_ASSET__1eb3ad0b__"